export default {"src":"/_next/static/media/unlock.8bb5183b.svg","height":30,"width":32};